import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReservationReportResponseV4Schema } from "../response/ReservationReportResponseV4";
import { ReservationReportFilterV4Type } from "../schema/ReservationReportFilterSchemaV4";

const API_VERSION = 'v4';

interface ReservationReportV4Props {
    filter?: ReservationReportFilterV4Type;
    type: string | null;
}

const useReservationReportV4 = (params: ReservationReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-report-reservation',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter)
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-reservation`, {
                    filter: params.filter
                });

                const validationResult = ReservationReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Reservation report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Reservation report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && params.type === "report_reservation",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useReservationReportV4;